<template>
  <painel-component :items="itemsOne">
    <div class="d-flex flex-column flex-md-row justify-content-between align-items-center" v-if="viewPage">
      <div class="pt-3 text-uppercase">
        <h5 class="text-dark">
          <span class="badge rounded-pill text-bg-dark me-2">{{ statusString(formData.status) }}</span>
          <span class="badge rounded-pill text-bg-dark">Código: {{ formData.code }}</span>
        </h5>
      </div>
      <div class="d-flex align-items-center justify-content-end m-3 gap-1">
        <button-submit icon="print" @click="openPDF(formData.urlPrint)" />
        <button-submit icon="send" @click="openModalStatus = true" />
        <button-route :items="itemsTwo" />
      </div>
    </div>

    <div class="card mt-3 p-3" v-if="viewPage">
      <div class="d-flex justify-content-between align-items-center">
        <h6 class="text-uppercase mb-0">Cliente</h6>
        <button-submit v-if="!disabled" icon="edit" @click="openModalEditClient = true" />
      </div>

      <form class="mt-3">
        <row-component>
          <col-component class-col="col-xxl-9 col-xl-9 col-lg-8 col-md-12 col-sm-12 col-12">
            <label>Cliente:</label>
            <input-component v-model="formData.client_name" disabled />
          </col-component>

          <col-component class-col="col-xxl-3 col-xl-3 col-lg-4 col-md-12 col-sm-12 col-12">
            <label>Valor frete:</label>
            <input-component v-model="formData.freight_price" disabled />
          </col-component>
        </row-component>

        <row-component>
          <col-component class-col="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <label>Descrição:</label>
        <text-area :model-value="formData.description || ''" disabled />
          </col-component>
        </row-component>
      </form>
    </div>

    <div class="card mt-4 p-3" v-if="viewPage">
      <div class="d-flex justify-content-between align-items-center">
        <h6 class="text-uppercase mb-0">Produto</h6>
        <button-submit v-if="!disabled" icon="plus" @click="openAddProductManual" />
      </div>

      <div class="bg-body-secondaryd mt-3">
        <div class="bg-white">
          <div class="__table">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col" style="width: 12%">Foto</th>
                  <th scope="col" style="width: 12%">Código</th>
                  <th scope="col" style="width: 18%">Peça</th>
                  <th scope="col" style="width: 8%">Qtd</th>
                  <th scope="col" style="width: 10%">Preço UN</th>
                  <th scope="col" style="width: 10%">Preço total</th>
                  <th scope="col" style="width: 10%">Peso (g)</th>
                  <th scope="col" style="width: 10%">Peso total</th>
                  <th scope="col" style="width: 10%" v-if="!disabled">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="part in formData.parts" :key="part.id">
                  <td data-label="Foto">
                    <img class="rounded-circle" width="50" :src="part.photo" alt="" />
                  </td>
                  <td data-label="Código">{{ part.ref }}</td>
                  <td data-label="Peça">{{ part.name }}</td>
                  <td data-label="Qtd">{{ part.amount }}</td>
                  <td data-label="Preço UN">{{ part.price }}</td>
                  <td data-label="Preço total">{{ part.price_total }}</td>
                  <td data-label="Peso (g)">{{ part.kilo }}</td>
                  <td data-label="Peso total">{{ part.kilo_total }}</td>
                  <td data-label="Ações" v-if="!disabled">
                    <button-submit class="me-1" icon="edit" @click="openEditProduct(part)" />
                    <button-delete @click="destroyProduct(part)" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row bg-black text-white py-2 mx-0">
            <div class="col-md-4 px-2">Quantidade total: {{ formData.totalPartAmount }}</div>
            <div class="col-md-4 px-2">Peso total: {{ formData.totalPartKilo }}</div>
            <div class="col-md-4 px-2">Valor total: {{ formData.totalPartPrice }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="card mt-4 p-3" v-if="viewPage">
      <div class="d-flex justify-content-between align-items-center">
        <h6 class="text-uppercase mb-0">Desconto</h6>
        <div v-if="!disabled">
          <template v-if="formData.discount">
            <button-submit class="me-1" icon="edit" @click="openModalDiscount = true" />
            <button-delete @click="destroyDiscount" />
          </template>
          <button-submit v-else icon="plus" @click="openModalDiscount = true" />
        </div>
      </div>

      <form class="mt-3" v-if="formData.discount">
        <row-component>
          <col-component class-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
            <label>Valor total:</label>
            <input-component v-model="formData.totalPartPrice" disabled />
          </col-component>
          <col-component class-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
            <label>Desconto %:</label>
            <input-component :model-value="formData.discount.percentage" disabled />
          </col-component>
          <col-component class-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
            <label>Valor desconto:</label>
            <input-component :model-value="formData.discount.price" disabled />
          </col-component>
        </row-component>
      </form>
    </div>

    <div class="card mt-4 p-3" v-if="viewPage">
      <div class="d-flex justify-content-between align-items-center">
        <h6 class="text-uppercase mb-0">Formas de pagamento</h6>
        <button-submit v-if="!disabled" icon="plus" @click="openModalAddPayment = true" />
      </div>

      <div class="__table mt-3">
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col" style="width: 20%">Forma</th>
              <th scope="col" style="width: 15%">Data</th>
              <th scope="col" style="width: 15%">Preço</th>
              <th scope="col" style="width: 10%">Quantidade</th>
              <th scope="col" style="width: 15%">Preço total</th>
              <th scope="col" style="width: 15%">Fluxo caixa gerado</th>
              <th scope="col" style="width: 10%" v-if="!disabled">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="payment in formData.payments" :key="payment.id">
              <td data-label="Forma">{{ payment.name_payment }}</td>
              <td data-label="Data">{{ payment.date_create }}</td>
              <td data-label="Preço">{{ payment.price }}</td>
              <td data-label="Quantidade">{{ payment.amount }}</td>
              <td data-label="Preço total">{{ payment.price_total }}</td>
              <td data-label="Fluxo caixa gerado">{{ yesNoString(payment.cash_flow_generate) }}</td>
              <td data-label="Ações" v-if="!disabled">
                <button-submit class="me-1" icon="edit" @click="openEditPayment(payment)" />
                <button-delete @click="destroyPayment(payment)" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="card mt-4 p-3" v-if="viewPage">
      <h6 class="text-uppercase">Fechamento</h6>
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col" style="width: 25%">Total peso (g)</th>
            <th scope="col" style="width: 25%">Total quantidade</th>
            <th scope="col" style="width: 25%">Total valor</th>
            <th scope="col" style="width: 25%">Total descontos</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td data-label="Total peso (g)">{{ formData.totalPartKilo }}</td>
            <td data-label="Total quantidade">{{ formData.totalPartAmount }}</td>
            <td data-label="Total valor">{{ formData.totalPartPrice }}</td>
            <td data-label="Total descontos">-{{ formData.totalDiscount }}</td>
          </tr>
        </tbody>
      </table>

      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col" style="width: 25%">Subtotal</th>
            <th scope="col" style="width: 25%">Preço pago</th>
            <th scope="col" style="width: 25%">Preço em aberto</th>
            <th scope="col" style="width: 25%">Troco</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td data-label="Subtotal">{{ formData.subtotal }}</td>
            <td data-label="Preço pago">{{ formData.pricePaid }}</td>
            <td data-label="Preço em aberto">{{ formData.openPrice }}</td>
            <td data-label="Troco">{{ formData.change }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="openModalStatus" class="modal-overlay" @click.self="openModalStatus = false">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="mb-0">Atualizar status</h5>
          <div role="button" class="btn-close" @click="openModalStatus = false"></div>
        </div>
        <div class="modal-body">
          <row-component>
            <col-component
              class-col="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12"
              v-for="status in statusOptions"
              :key="status.value"
            >
              <div class="d-flex align-items-center bg-body-secondary p-3 position-relative mt-2">
                <div class="ms-1 w-75">
                  <p class="mb-0 text-truncate">{{ status.label }}</p>
                </div>
                <div class="position-absolute end-0 me-1 me-lg-3">
                  <button-submit icon="send" @click="submitStatus(status.value)" />
                </div>
              </div>
            </col-component>
          </row-component>
        </div>
      </div>
    </div>

    <OrderPartEditClient
      v-if="openModalEditClient"
      :item-data="formData"
      @close="openModalEditClient = false"
      @saved="loadOrderPart"
    />

    <OrderPartAddProduct
      v-if="openModalAddProduct"
      :key="barcode || 'manual'"
      :order-part-id="id"
      :barcode="barcode"
      @close="closeAddProduct"
      @saved="loadOrderPart"
    />

    <OrderPartEditProduct
      v-if="openModalEditProduct && itemEditProduct"
      :item-data="itemEditProduct"
      @close="openModalEditProduct = false"
      @saved="loadOrderPart"
    />

    <OrderPartDiscount
      v-if="openModalDiscount"
      :item-data="formData"
      @close="openModalDiscount = false"
      @saved="loadOrderPart"
    />

    <OrderPartAddPayment
      v-if="openModalAddPayment"
      :order-part-id="id"
      @close="openModalAddPayment = false"
      @saved="loadOrderPart"
    />

    <OrderPartEditPayment
      v-if="openModalEditPayment && itemPayment"
      :order-part-id="id"
      :item-data="itemPayment"
      @close="openModalEditPayment = false"
      @saved="loadOrderPart"
    />
  </painel-component>
</template>

<script>
import PainelComponent from '@/components/dashboard/PainelComponent.vue';
import RowComponent from '@/components/row/RowComponent.vue';
import ColComponent from '@/components/row/ColComponent.vue';
import InputComponent from '@/components/form/InputComponent.vue';
import TextArea from '@/components/form/TextArea.vue';
import ButtonSubmit from '@/components/buttons/ButtonSubmit.vue';
import ButtonRoute from '@/components/buttons/ButtonRoute.vue';
import ButtonDelete from '@/components/buttons/ButtonDelete.vue';
import OrderPartEditClient from '@/components/modal/OrderPartEditClient.vue';
import OrderPartAddProduct from '@/components/modal/OrderPartAddProduct.vue';
import OrderPartEditProduct from '@/components/modal/OrderPartEditProduct.vue';
import OrderPartDiscount from '@/components/modal/OrderPartDiscount.vue';
import OrderPartAddPayment from '@/components/modal/OrderPartAddPayment.vue';
import OrderPartEditPayment from '@/components/modal/OrderPartEditPayment.vue';
import '@/assets/css/table.css';
import swal from 'sweetalert';
import { useToast } from 'vue-toastification';

const toast = useToast();

export default {
  name: 'OrderPartUpdate',

  components: {
    PainelComponent,
    RowComponent,
    ColComponent,
    InputComponent,
    TextArea,
    ButtonSubmit,
    ButtonRoute,
    ButtonDelete,
    OrderPartEditClient,
    OrderPartAddProduct,
    OrderPartEditProduct,
    OrderPartDiscount,
    OrderPartAddPayment,
    OrderPartEditPayment
  },

  props: {
    id: {
      required: true
    }
  },

  created() {
    this.$store.dispatch('changeNamePage', 'Pedido');
    this.loadOrderPart();
    this.checkACL();
  },

  mounted() {
    window.addEventListener('keydown', this.onKeyDown, true);
  },

  beforeUnmount() {
    window.removeEventListener('keydown', this.onKeyDown, true);
    clearTimeout(this.barcodeTimeout);
  },

  data() {
    return {
      itemsOne: {
        title: 'Editar',
        icon: 'edit'
      },
      itemsTwo: {
        route: '/order-part/search',
        icon: 'reply all',
        name: 'Voltar'
      },
      formData: {
        client_name: '',
        description: '',
        freight_price: '',
        code: '',
        status: '',
        parts: [],
        payments: [],
        discount: null
      },
      viewPage: false,
      openModalStatus: false,
      openModalEditClient: false,
      openModalAddProduct: false,
      openModalEditProduct: false,
      openModalDiscount: false,
      openModalAddPayment: false,
      openModalEditPayment: false,
      itemEditProduct: null,
      itemPayment: null,
      barcode: '',
      barcodeBuffer: '',
      barcodeTimeout: null
    };
  },

  computed: {
    disabled() {
      return Number(this.formData.status) > 2;
    },
    selectStatusComplete() {
      return this.$store.state.var.selectStatusComplete;
    },
    statusOptions() {
      return this.selectStatusComplete.filter(item => Number(item.value) !== Number(this.formData.status));
    }
  },

  methods: {
    loadOrderPart() {
      this.$store
        .dispatch('loadOrderPart', this.id)
        .then(r => {
          this.formData = {
            ...r,
            client_name: r.client_name || '',
            description: r.description || '',
            freight_price: r.freight_price || '0,00',
            parts: r.parts || [],
            payments: r.payments || [],
            discount: r.discount || null
          };
        })
        .catch(() => {
          toast.error('Erro ao carregar pedido', { timeout: 1500 });
        });
    },

    async checkACL() {
      this.$store
        .dispatch('ACLItems', 8)
        .then(r => {
          if (r.indexOf('order-part-edit') !== -1) {
            this.viewPage = true;
          } else {
            this.$router.push({ name: 'home' });
          }
        })
        .catch(() => {
          this.$router.push({ name: 'home' });
        });
    },

    statusString(value) {
      const status = this.selectStatusComplete.find(item => Number(item.value) === Number(value));
      return status ? status.label : '';
    },

    yesNoString(value) {
      return Number(value) === 2 ? 'Sim' : 'Não';
    },

    openPDF(link) {
      if (link) window.open(link, '_blank');
    },

    submitStatus(status) {
      this.$store
        .dispatch('updateOrderPartStatus', { id: this.id, status })
        .then(() => {
          this.openModalStatus = false;
          this.loadOrderPart();
          toast.success('Cadastro atualizado com sucesso', { timeout: 1500 });
        })
        .catch(() => {
          toast.error('Erro ao atualizar status', { timeout: 1500 });
        });
    },

    openEditProduct(part) {
      this.itemEditProduct = part;
      this.openModalEditProduct = true;
    },

    openEditPayment(payment) {
      this.itemPayment = payment;
      this.openModalEditPayment = true;
    },

    closeAddProduct() {
      this.openModalAddProduct = false;
      this.barcode = '';
      this.resetBarcodeBuffer();
    },

    openAddProductManual() {
      this.barcode = '';
      this.resetBarcodeBuffer();
      this.openModalAddProduct = true;
    },

    hasBlockingModal() {
      return (
        this.openModalStatus ||
        this.openModalEditClient ||
        this.openModalEditProduct ||
        this.openModalDiscount ||
        this.openModalAddPayment ||
        this.openModalEditPayment
      );
    },

    setCodeBar(code) {
      this.barcode = String(code || '').trim();
      if (!this.barcode) return;
      this.openModalAddProduct = true;
    },

    resetBarcodeBuffer() {
      clearTimeout(this.barcodeTimeout);
      this.barcodeBuffer = '';
    },

    setTimeoutCodeBar() {
      clearTimeout(this.barcodeTimeout);
      this.barcodeTimeout = setTimeout(() => {
        this.barcodeBuffer = '';
      }, 1000);
    },

    isBarcodeChar(key) {
      return key && key.length === 1 && key !== ' ';
    },

    destroyProduct(part) {
      swal({
        title: 'Atenção!',
        text: `Deseja realmente deletar este produto: ${part.name}?`,
        closeOnClickOutside: false,
        buttons: {
          cancel: { text: 'Não', visible: true, closeModal: true },
          confirm: 'Sim'
        }
      }).then(result => {
        if (result) {
          this.$store
            .dispatch('destroyOrderPartItem', part.id)
            .then(() => {
              this.loadOrderPart();
              toast.success('Produto deletado com sucesso!', { timeout: 1500 });
            })
            .catch(() => {
              toast.error('Erro ao deletar produto', { timeout: 1500 });
            });
        }
      });
    },

    destroyDiscount() {
      swal({
        title: 'Atenção!',
        text: `Deseja realmente deletar este desconto de ${this.formData.discount.percentage}%?`,
        closeOnClickOutside: false,
        buttons: {
          cancel: { text: 'Não', visible: true, closeModal: true },
          confirm: 'Sim'
        }
      }).then(result => {
        if (result) {
          this.$store
            .dispatch('destroyOrderPartDiscount', this.formData.discount.id)
            .then(() => {
              this.loadOrderPart();
              toast.success('Desconto deletado com sucesso!', { timeout: 1500 });
            })
            .catch(() => {
              toast.error('Erro ao deletar desconto', { timeout: 1500 });
            });
        }
      });
    },

    destroyPayment(payment) {
      swal({
        title: 'Confirmar exclusão',
        text: `Deseja realmente deletar o pagamento: ${payment.name_payment}, no valor de R$ ${payment.price_total}?`,
        closeOnClickOutside: false,
        buttons: {
          cancel: { text: 'Não', visible: true, closeModal: true },
          confirm: 'Sim'
        }
      }).then(result => {
        if (result) {
          this.$store
            .dispatch('destroyOrderPartPayment', payment.id)
            .then(() => {
              this.loadOrderPart();
              toast.success('Cadastro deletado com sucesso', { timeout: 1500 });
            })
            .catch(() => {
              toast.error('Erro ao deletar pagamento', { timeout: 1500 });
            });
        }
      });
    },

    onKeyDown(event) {
      if (this.disabled || this.hasBlockingModal()) return;

      if (this.openModalAddProduct) return;

      if (event.key === 'Enter') {
        const code = (this.barcodeBuffer || '').trim();
        if (code) {
          event.preventDefault();
          event.stopPropagation();
          this.setCodeBar(code);
        }
        this.resetBarcodeBuffer();
        return;
      }

      if (
        event.key === 'Shift' ||
        event.key === 'Control' ||
        event.key === 'Alt' ||
        event.key === 'Meta' ||
        event.key === 'Tab' ||
        event.key === 'Escape' ||
        event.key === 'Backspace' ||
        event.key === 'CapsLock' ||
        event.key.startsWith('Arrow')
      ) {
        return;
      }

      if (this.isBarcodeChar(event.key)) {
        this.barcodeBuffer += event.key;
        this.setTimeoutCodeBar();
      }
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  padding: 20px;
  width: 800px;
  max-width: 90%;
  position: relative;
  max-height: 70%;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
</style>
